export default {
    state: {
        cards: []
    },
    namespaced: true,
    mutations: {
        add: (state, card) => {
            const index = state.cards.findIndex(c => c.key === card.key);
            if (index < 0) {
                const temp = [...state.cards];
                temp.push(card)
                state.cards = temp;
            } else {
                const temp = [...state.cards];
                temp[index].minimized = false;
                state.cards = [...temp];
            }
        },
        remove: (state, key) => {
            const index = state.cards.findIndex(c => c.key === key);
            if (index > -1) {
                const temp = [...state.cards];
                temp.splice(index, 1);
                state.cards = [...temp];
            }
        },
        minimize: (state, key) => {
            const index = state.cards.findIndex(c => c.key === key);
            if (index > -1) {
                const temp = [...state.cards];
                temp[index].minimized = true;
                state.cards = [...temp];
            }
        },
        maximize: (state, key) => {
            const index = state.cards.findIndex(c => c.key === key);
            if (index > -1) {
                const temp = [...state.cards];
                temp[index].minimized = false;
                state.cards = [...temp];
            }
        },
    },
    actions: {
        ADD: ({commit}, card) => {
            commit('add', card);
        },
        REMOVE: ({commit}, key) => {
            commit('remove', key);
        },
        MINIMIZE: ({commit}, key) => {
            commit('minimize', key);
        },
        MAXIMIZE: ({commit}, key) => {
            commit('maximize', key);
        },
    },
    getters: {
        affiliateCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'affiliate')
        },
        paymentCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'payment')
        },
        maximizedCards: (state) => {
            return state.cards.filter(c => c.minimized === false)
        }
    }
};
